export function addSpacesBetweenUppercase(inputString: string): string { 
    inputString = inputString?.replace(/([A-Z])/g, ' $1').trim();
    return inputString;
} 

export function toTitleCase(inputString: string): string {
    return inputString?.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase());
}